import type { Theme } from '@goodtime/engine';
import { buildSlotAssets } from './slotAssets';

const ASSETS = buildSlotAssets('glitch', {
  cherry: 'pixel_block',
  lemon: 'code_bracket',
  orange: 'error_triangle',
  bell: 'glitch_bell',
  star: 'glitch_wild',
  seven: 'cpu_core',
  gem: 'data_shard',
  scatter: 'cursor_scatter',
  money: 'data_jackpot',
});

/** Glitch — GENERATED by scaffoldSlot from
 *  content/slots/glitch.slot.json.
 *  Edit the spec and regenerate rather than hand-editing this file
 *  (hand edits are overwritten on the next scaffold run). */
export const GLITCH_THEME: Theme = {
  id: 'glitch',
  name: 'Glitch',
  palette: {
    accent: 0xff2ea8,
    secondary: 0xff8ad0,
    warm: 0xf2d27a,
    frameFill: 0x1e0a18,
    bgGradientTop: 0x3a1030,
    bgGradientBottom: 0x12040d,
    dimOverlay: 0x080209,
  },
  slot: {
    symbols: [
      { id: 'cherry', label: 'Pixel', glyph: '🟪', tint: 0xc040a0, weight: 5, textureAlias: 'glitch:cherry',
        winVideoAlias: 'glitch:cherry:win:video', winVideoSpeed: 2 },
      { id: 'lemon', label: 'Code', glyph: '🔡', tint: 0x40a0e0, weight: 5, textureAlias: 'glitch:lemon',
        winVideoAlias: 'glitch:lemon:win:video', winVideoSpeed: 2 },
      { id: 'orange', label: 'Error', glyph: '⚠️', tint: 0xe0a040, weight: 4, textureAlias: 'glitch:orange',
        winVideoAlias: 'glitch:orange:win:video', winVideoSpeed: 2 },
      { id: 'bell', label: 'System Bell', glyph: '🔔', tint: 0xc0c0d0, weight: 3, textureAlias: 'glitch:bell',
        winVideoAlias: 'glitch:bell:win:video', winVideoSpeed: 2 },
      { id: 'star', label: 'Glitch', glyph: '👾', tint: 0xff2ea8, weight: 2, textureAlias: 'glitch:star',
        winVideoAlias: 'glitch:star:win:video', winVideoSpeed: 2 },
      { id: 'seven', label: 'Core', glyph: '💠', tint: 0x9040d0, weight: 2, textureAlias: 'glitch:seven',
        winVideoAlias: 'glitch:seven:win:video', winVideoSpeed: 2 },
      { id: 'gem', label: 'Shard', glyph: '💎', tint: 0xe040c0, weight: 2.5, textureAlias: 'glitch:gem',
        winVideoAlias: 'glitch:gem:win:video', winVideoSpeed: 2 },
      { id: 'scatter', label: 'Cursor', glyph: '🖱️', tint: 0xc0c0c8, weight: 0.5, textureAlias: 'glitch:scatter',
        winVideoAlias: 'glitch:scatter:win:video', winVideoSpeed: 2 },
      { id: 'money', label: 'Data Cache', glyph: '💰', tint: 0xf0c860, weight: 1, textureAlias: 'glitch:money',
        winVideoAlias: 'glitch:money:win:video', winVideoSpeed: 2, isMoney: true },
      // Gem-on-reel — producer brief 2026-06-04. Scatter-style bonus
      // shared across every biome (registered via SHARED_REEL_SYMBOLS
      // in themes/index.ts). Weights deliberately rare so a gem
      // landing feels like a treat rather than background noise.
      { id: 'gem_t5',  label: 'Gems',     glyph: '💎', tint: 0x3ea7e8, weight: 0.10, gemValue: 5,  textureAlias: 'shared:reel:gem_5' },
      { id: 'gem_t10', label: 'Gem Pile', glyph: '💎', tint: 0x3ea7e8, weight: 0.05, gemValue: 10, textureAlias: 'shared:reel:gem_10' },
    ],
    wildSymbolId: 'star',
    scatterSymbolId: 'scatter',
  },
  wheel: {
    segments: [
      { id: 'x0-a', kind: 'multiplier', label: '✕', tint: 0x1e0a18, multiplier: 0, weight: 4 },
      { id: 'x1-a', kind: 'multiplier', label: '×1', tint: 0xff2ea8, multiplier: 1, weight: 4 },
      { id: 'x2-a', kind: 'multiplier', label: '×2', tint: 0xf2d27a, multiplier: 2, weight: 3 },
      { id: 'x0-b', kind: 'multiplier', label: '✕', tint: 0x1e0a18, multiplier: 0, weight: 3 },
      { id: 'x3-a', kind: 'multiplier', label: '×3', tint: 0xff8ad0, multiplier: 3, weight: 3 },
      { id: 'x1-b', kind: 'multiplier', label: '×1', tint: 0xff2ea8, multiplier: 1, weight: 3 },
      { id: 'x5-a', kind: 'multiplier', label: '×5', tint: 0xf2d27a, multiplier: 5, weight: 2 },
      { id: 'x0-c', kind: 'multiplier', label: '✕', tint: 0x1e0a18, multiplier: 0, weight: 3 },
      { id: 'x2-b', kind: 'multiplier', label: '×2', tint: 0xf2d27a, multiplier: 2, weight: 2 },
      { id: 'x10-a', kind: 'multiplier', label: '×10', tint: 0xff2ea8, multiplier: 10, weight: 2 },
      { id: 'x5-b', kind: 'multiplier', label: '×5', tint: 0xf2d27a, multiplier: 5, weight: 2 },
      { id: 'x25-a', kind: 'multiplier', label: '×25', tint: 0xf2d27a, multiplier: 25, weight: 1 },
    ],
  },
  assets: {
    slot: ASSETS.slot,
    slotWin: ASSETS.slotWin,
    scene: {
      background: { alias: 'glitch:bg', path: 'environment/glitch.png' },
      columnBackground: { alias: 'glitch:column_bg', path: 'reel/glitch_column_bg.png' },
      border: { alias: 'glitch:border', path: 'brand/border_neon.png' },
    },
  },
};
